module.exports = __webpack_public_path__ + "static/media/dlp_puzzles.d6b969bb.svg";